var map = {
	"./acrobat.png": "887b",
	"./amnesiac.png": "043b",
	"./apprentice.png": "4bea",
	"./artist.png": "2cd0",
	"./assassin.png": "9187",
	"./balloonist.png": "65db",
	"./barber.png": "fcc6",
	"./barista.png": "027a",
	"./baron.png": "24d3",
	"./beggar.png": "cfcc",
	"./bishop.png": "8030",
	"./bonecollector.png": "23b1",
	"./bureaucrat.png": "25f6",
	"./butcher.png": "37dd",
	"./butler.png": "64fe",
	"./cannibal.png": "5bd9",
	"./cerenovus.png": "0436",
	"./chambermaid.png": "125e",
	"./chef.png": "1e83",
	"./clockmaker.png": "f93f",
	"./courtier.png": "ee02",
	"./custom.png": "fd83",
	"./deviant.png": "3b65",
	"./devilsadvocate.png": "cd8b",
	"./dreamer.png": "71b8",
	"./drunk.png": "d97d",
	"./empath.png": "bb7a",
	"./evil.png": "c24f",
	"./eviltwin.png": "e014",
	"./exorcist.png": "5072",
	"./fanggu.png": "6ac0",
	"./fisherman.png": "c5db",
	"./flowergirl.png": "66ae",
	"./fool.png": "4720",
	"./fortuneteller.png": "43e8",
	"./gambler.png": "dce6",
	"./goblin.png": "5c8e",
	"./godfather.png": "99d0",
	"./good.png": "667e",
	"./goon.png": "55aa",
	"./gossip.png": "cadc",
	"./grandmother.png": "c9f5",
	"./gunslinger.png": "ee92",
	"./harlot.png": "559e",
	"./imp.png": "3e70",
	"./innkeeper.png": "663c",
	"./investigator.png": "b570",
	"./judge.png": "f09b",
	"./juggler.png": "65ab",
	"./klutz.png": "adfc",
	"./leviathan.png": "2b04",
	"./librarian.png": "4d73",
	"./lunatic.png": "0b61",
	"./mastermind.png": "f834",
	"./mathematician.png": "8888",
	"./matron.png": "b1cb",
	"./mayor.png": "b223",
	"./minstrel.png": "4efd",
	"./monk.png": "6741",
	"./moonchild.png": "3f65",
	"./mutant.png": "17ad",
	"./nodashii.png": "68a4",
	"./oracle.png": "0c12",
	"./pacifist.png": "fff1",
	"./philosopher.png": "3603",
	"./pithag.png": "7f07",
	"./plus.png": "160b",
	"./po.png": "c73a",
	"./poisoner.png": "f282",
	"./professor.png": "b30c",
	"./pukka.png": "a6a2",
	"./ravenkeeper.png": "0c59",
	"./recluse.png": "177d",
	"./sage.png": "30b6",
	"./sailor.png": "223c",
	"./saint.png": "6936",
	"./savant.png": "d715",
	"./scapegoat.png": "327a",
	"./scarletwoman.png": "f322",
	"./seamstress.png": "ac7c",
	"./shabaloth.png": "0b29",
	"./slayer.png": "d62b",
	"./snakecharmer.png": "4021",
	"./soldier.png": "4e76",
	"./spy.png": "ec1e",
	"./sweetheart.png": "f1e5",
	"./tealady.png": "ba9b",
	"./thief.png": "9ce3",
	"./tinker.png": "9f7e",
	"./towncrier.png": "38a5",
	"./undertaker.png": "0e20",
	"./vigormortis.png": "f4bd",
	"./virgin.png": "eff4",
	"./vortox.png": "3a43",
	"./voudon.png": "a710",
	"./washerwoman.png": "013f",
	"./widow.png": "22c9",
	"./witch.png": "f558",
	"./x.png": "5cf2",
	"./zombuul.png": "20ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";